import {useState, useEffect} from "react";
import {withTranslation} from "react-i18next";
import "../../ceiba.scss";
import {Button, Progress, Spin} from 'antd';
import {CheckCircleOutlined} from "@ant-design/icons";
import {history} from "../../../../../_helpers";
import {xcService} from "../../../../../_services/xcService";
import endpoint from "shared/endpoints";

function WorldCeiba(props) {

    const {t, i18n} =props;
    const [answers, setAnswers] = useState([]);
    const [questions, setQuestions] = useState(-1);
    const [loading, setLoading] = useState(true);

    const [_, setStudentArea] = useState(); // TODO: no tiene proposito
    const [__, setStudentAreaCervo] = useState(); // TODO: no tiene proposito
    const fetchData = async () => {
        try {
            let apiEndpoint = endpoint.studentAnswer.getAll('CEIBA');
            const responseA = await xcService.getToken(apiEndpoint);
            if (responseA && responseA.data && responseA.data.data)
                setAnswers(responseA.data.data)

            apiEndpoint = "/v1/student/assessments/CEIBA";
            const responseQ = await xcService.getToken(apiEndpoint);
            setQuestions(responseQ && responseQ.data && responseQ.data.data ? responseQ.data.data?.length : 0);
            setLoading(false)

            const areaPath = `/v1/student/area/CEIBA`
            await xcService.getToken(areaPath).then(({data}) => setStudentArea(data.data));

            const areaCevoPath = `/v1/student/area/CERVO`
            await xcService.getToken(areaCevoPath).then(({data}) => setStudentAreaCervo(data.data));

        } catch (e) {
            setLoading(false)
        }
    }
    useEffect(() => {
        fetchData();
    }, []);


    const goTo = () => {
        if (answers && answers.length > 0){
            history.push("/admin/start-ceiba")
        }else {
            history.push("/admin/ceiba")
        }
    }


    return (


        <div className={"selectQ ceiba"}>
            {!loading ?
                <>
                <div className={"wrapper"}>
                    <div>
                        <p>{t("world.stepceiba")}</p>
                        <h2>{t("world.ceiba")}</h2>
                    </div>
                    <h3>{t("world.descceiba")}</h3>
                    <Button  onClick={() => goTo()}
                             type={"primary"}
                             className="buttonSizeXM btnBorder"
                    >
                        {t("enter")}
                    </Button>
                    {  props.finish && questions === answers.length ?
                      <div className={"posend"}>
                          <CheckCircleOutlined style={{ fontSize: 40}} />
                      </div> :
                      questions !== -1 ?
                        <div className={"posend"}>
                            <Progress width={50} type="circle" percent={ ((answers.length * 100) / (questions)) } format={() => ""} />
                        </div>
                        :
                        <div className={"posend"}></div>
                    }
                </div>
                <Button  onClick={() => goTo()}
                         type={"primary"}
                         className="btnBorder is-mobile-wh"
                >
                    {t("world.mceiba")} {props.finish && questions === answers.length &&
                        <div className={"posendmobile"}>
                            <CheckCircleOutlined style={{fontSize: 14}} /></div>
                    }
                </Button>
                </> : <Spin />}
        </div>
    )
}

export default withTranslation()(WorldCeiba);
